import React, { Component } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';

const styles = (theme) => ({
  bg: {
    width: '100%',
    // height: 'calc(100vh - 85px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
  },
  bg_about_dw: {
    width: '100%',
    color: '#555555',
    backgroundColor: '#ffffff',
    margin: '8vh 0',
    backgroundImage: `url('/images/bg_about_dw.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundPosition: '100% 0%',
  },
  txtWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  txtMob: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});

class AboutDw extends Component {
  constructor(props) {
    super(props);
    this.state = { matches: window.matchMedia('(max-width:600px)').matches };
  }
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Topbar />
        <div className={classes.bg}>
          <Grid id="Positioning_grid" container justify="center" style={{ padding: '0 30px' }}>
            <Grid container justify="flex-start" style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}>
              <b>회사소개 〉 (주)두원시스템</b>
            </Grid>
            <Grid
              id="content_main_grid"
              container
              justify="center"
              item
              xs={12}
              md={8}
              style={{ backgroundColor: '#ffffff', margin: '6vh 0', borderRadius: '20px' }}
            >
              <img
                src="/images/bg_about_dw_new.png"
                alt={'img'}
                style={{
                  width: this.state.matches ? '80%' : '60%',
                  //maxHeight: this.state.matches ? '40vh' : '',
                  marginBottom: '8vh',
                  borderRadius: '3vw',
                }}
                onContextMenu={(e) => e.preventDefault()}
              />
              <Grid
                id="content_inner_grid"
                container
                item
                xs={11}
                md={10}
                style={{ paddingBottom: '4vh', marginBottom: '8vh', borderBottom: '1px solid #2a285e ', wordBreak: 'keep-all' }}
              >
                <Grid id="borderline_grid" container style={{ marginBottom: '4vh' }}>
                  <Grid container item xs={3} style={{ borderTop: '5px solid #2a285e' }}></Grid>
                  <Grid container item xs={9} style={{ borderTop: '1.5px solid #2a285e' }}></Grid>
                </Grid>

                <Grid item xs={12} md={3} container justify="center" style={{ color: '#1d1b54', fontSize: '1.3em', fontWeight: '900' }}>
                  <span style={{ marginBottom: '3vh' }}>(주) 두원시스템</span>
                </Grid>
                <Grid item xs={12} md={9}>
                  <Grid>
                    <div style={{ textAlign: 'center', fontSize: '1.1em', lineHeight: '1.8em' }} className={classes.txtMob}>
                      (주)두원시스템은 1996년 7월 6일 설립 이후,
                      <br /> IMF등 어려운 경제여건 속에서도
                      <br /> 전 임직원이 화합하여 <br />
                      탄탄한 기술력과 기획력,영업력으로
                      <br /> 지속적인 성장을 해 왔습니다.
                      <br />
                      <br /> 2015년부터는 대한민국 관광활성화와
                      <br /> 지역경제발전을 위해 국내 지자체를 대상으로
                      <br /> 오프라인 "스탬프투어 통합솔루션"을
                      <br /> 수행하게 되었고,
                      <b>
                        국내 최초로
                        <br /> "보안형 고정 원터치식 스탬핑 유닛과
                        <br /> 인증 스탬핑 유닛",
                        <br /> "임의 날인방지 스탬핑 유닛"의 개발에 성공,
                        <br /> 8종의 특허를 획득
                      </b>
                      하였으며, <br />
                      이를 계기로 각 지자체 및 대상처에서의
                      <br /> 시설 요청이 폭발적으로
                      <br /> 늘어나기 시작 했습니다.
                      <br />
                      <br />
                      마침내, 2018년도에는 미력하나마
                      <br /> 국내 관광활성화에 기여한 공로 및<br /> 지속적인 발전 가능성을 인정받아{' '}
                      <b>
                        국내 최초로
                        <br /> "스탬프투어 통합솔루션 관광벤처기업"으로
                        <br /> 선정
                      </b>
                      되어 더욱 더 관광활성화에
                      <br /> 박차를 가할 계기가 되었습니다.
                      <br />
                      <br />
                      현재,
                      <b>
                        "훼손방지형 자동문닫힘 장치 및 <br /> 스탬프 인증 유닛" 14종과 <br /> "고품위 스탬프 및 고성능 스탬프 인증 유닛"{' '}
                        <br />
                        8종이 특허출원중
                      </b>
                      에 있고, <br /> 향후에도 (주)두원시스템만의 독특한 기획, <br />
                      아이디어 및 지속적인 연구개발로 특허획득이 <br /> 계속적으로 이어질것 것입니다.
                      <br />
                      <br />
                      또한, 최근에는 그간에 구축한 <br /> 스탬프투어 시설 활용 및 <br /> 당사의 노하우를 토대로 <br /> 온오프라인
                      스탬프투어의 장점을 융합시킨 <br />
                      <b>
                        "스마트 스탬프투어 웹 통합솔루션"이라는 <br /> 새로운 플랫폼 서비스 체계를 구축
                      </b>
                      하여
                      <br /> 관광객 및 사용자에게는 추억과 감동,
                      <br /> 관광 안내 및 SNS를 통한 개인간 소통관광을
                      <br /> 선사 할 수 있게 해 드리고,
                      <br /> 각 지자체 및 대상처에는 관광 홍보는 물론,
                      <br /> 유지관리의 편리성까지 도모하고 있습니다.
                      <br />
                      <br />
                      이렇듯, 특화된 기술과 톡톡튀는 아이디어,
                      <br /> 더 나아가서는 장인정신을 바탕으로
                      <br />
                      "스탬프투어 통합컨설팅 및 스탬프,
                      <br /> 스탬프거치대, 스탬프인증대, 스탬프북 및<br /> 관광홍보물, 관광기념품,
                      <br /> 관광활성화 아이템 개발"에 이르기까지
                      <br /> 국내 관광활성화를 위해 수반되는
                      <br /> 통합적인 관광 관련업무를 수행 해 왔습니다.
                      <br />
                      <br />
                      이제부터 ㈜두원시스템은,
                      <br /> 이러한 오프라인 스탬프투어 시설을 활용하여
                      <br /> "스마트 스탬프투어 웹 통합솔루션"
                      <br /> 플랫폼 서비스를 제공하게 됨으로써, 명실공히
                      <br /> <b>"대한민국 스탬프투어 통합솔루션의 대표주자"</b> 로
                      <br /> 자리매김 하게 된 바, 궁극적으로
                      <br />
                      <b>
                        성공적인 스탬프투어로 정착시켜 국민의 여가,
                        <br /> 관광, 문화생활
                      </b>
                      을 재미있고
                      <br /> 즐겁게 해 드릴 뿐만 아니라,
                      <b>
                        국내 관광활성화와
                        <br /> 지역경제발전을 이룩
                      </b>
                      하고, 나아가서는
                      <br /> <b>외국 관광객의 한국방문을 유도</b> 할 수 있도록,
                      <br /> 국내 뿐만아니라 세계시장을 선도하는 업체로
                      <br /> 발전하고자 부단히 노력 할 것을 다짐 합니다.
                      <br />
                      <br />
                      <br />
                    </div>

                    <div style={{ textAlign: 'center', wordBreak: 'keep-all', lineHeight: '1.7em' }} className={classes.txtWeb}>
                      (주)두원시스템은 1996년 7월 6일 설립 이후, IMF등 어려운 경제여건 속에서도 전 임직원이 화합하여 탄탄한 기술력과
                      기획력,영업력으로 지속적인 성장을 해 왔습니다.
                      <br />
                      <br />
                      <br /> 2015년부터는 대한민국 관광활성화와 지역경제발전을 위해 국내 지자체를 대상으로 오프라인 "스탬프투어
                      통합솔루션"을 수행하게 되었고,
                      <b>
                        국내 최초로 "보안형 고정 원터치식 스탬핑 유닛과 인증 스탬핑 유닛", "임의 날인방지 스탬핑 유닛"의 개발에 성공, 8종의
                        특허를 획득
                      </b>
                      하였으며, 이를 계기로 각 지자체 및 대상처에서의 시설 요청이 폭발적으로 늘어나기 시작 했습니다.
                      <br />
                      <br />
                      <br />
                      마침내, 2018년도에는 미력하나마 국내 관광활성화에 기여한 공로 및 지속적인 발전 가능성을 인정받아{' '}
                      <b>국내 최초로 "스탬프투어 통합솔루션 관광벤처기업"으로 선정</b>되어 더욱 더 관광활성화에 박차를 가할 계기가
                      되었습니다.
                      <br />
                      <br />
                      <br />
                      현재,
                      <b>
                        "훼손방지형 자동문닫힘 장치 및 스탬프 인증 유닛" 14종과 "고품위 스탬프 및 고성능 스탬프 인증 유닛" 8종이 특허출원중
                      </b>
                      에 있고, 향후에도 (주)두원시스템만의 독특한 기획,아이디어 및 지속적인 연구개발로 특허획득이 계속적으로 이어질것
                      것입니다.
                      <br />
                      <br />
                      <br />
                      또한, 최근에는 그간에 구축한 스탬프투어 시설 활용 및 당사의 노하우를 토대로 온오프라인 스탬프투어의 장점을 융합시킨
                      <b>"스마트 스탬프투어 웹 통합솔루션"이라는 새로운 플랫폼 서비스 체계를 구축</b>하여 관광객 및 사용자에게는 추억과
                      감동, 관광 안내 및 SNS를 통한 개인간 소통관광을 선사 할 수 있게 해 드리고, 각 지자체 및 대상처에는 관광 홍보는 물론,
                      유지관리의 편리성까지 도모 해 드리고 있습니다.
                      <br />
                      <br />
                      <br />
                      이렇듯, 특화된 기술과 톡톡튀는 아이디어, 더 나아가서는 장인정신을 바탕으로 "스탬프투어 통합컨설팅 및 스탬프,
                      스탬프거치대, 스탬프인증대, 스탬프북 및 관광홍보물, 관광기념품, 관광활성화 아이템 개발"에 이르기까지 국내 관광활성화를
                      위해 수반되는 통합적인 관광 관련업무를 수행 해 왔습니다.
                      <br />
                      <br />
                      <br />
                      이제부터 ㈜두원시스템은, 이러한 오프라인 스탬프투어 시설을 활용하여 "스마트 스탬프투어 웹 통합솔루션" 플랫폼 서비스를
                      제공하게 됨으로써, <b>명실공히 "대한민국 스탬프투어 통합솔루션의 대표주자"로 자리매김</b> 하게 된 바, 궁극적으로
                      <b>성공적인 스탬프투어로 정착시켜 국민의 여가, 관광, 문화생활</b>을 재미있고 즐겁게 해 드릴 뿐만 아니라,
                      <b>국내 관광활성화와 지역경제발전을 이룩</b>하고, 나아가서는 <b>외국 관광객의 한국방문을 유도</b> 할 수 있도록, 국내
                      뿐만아니라 세계시장을 선도하는 업체로 발전하고자 부단히 노력 할 것을 다짐 합니다.
                      <br />
                      <br />
                      <br />
                    </div>
                  </Grid>
                  {/* --업체수정요청20210405-- */}
                  {/* <Grid id="content_inner_grid_bottom" container>
                    <Grid
                      item
                      xs={3}
                      md={2}
                      style={{ fontSize: '1.2em', color: '#555555', fontWeight: 'bold', borderTop: '5px solid #eeeeee', paddingTop: '4vh' }}
                    >
                      <span style={{ wordBreak: 'keep-all' }}>기업 목표</span>
                    </Grid>
                    <Grid item xs={9} md={10} style={{ borderTop: '1.5px solid #eeeeee', paddingTop: '4vh' }}>
                      (주)두원시스템은 스탬프투어 통합솔루션의 대표주자로서 국내뿐 아니라 세계 시장을 선도하는 업체로 발전하고자 확고한
                      의지로 새로운 기술 개발에 매진하고 있습니다.
                      <br />
                      <br />
                      <span style={{ color: '#2a285e', fontWeight: 'bold', fontSize: '1.1em' }}>
                        대한민국의 관광활성화 및 지역경제발전에 기여할것 입니다.
                      </span>
                    </Grid>
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AboutDw);
